import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Button, { ButtonProps } from 'src/app/atoms/Button/Button';
import RevenueCalculatorInput, { RevenueCalculatorInputProps } from './RevenueCalculatorInput';
import ListGroupItem, { ListGroupItemProps } from '../ListGroupItem/ListGroupItem';

export interface RevenueCalculatorInputsBlockProps {
  inputs: RevenueCalculatorInputProps[];
  listGroupItem: ListGroupItemProps;
  button?: ButtonProps;
}

const RevenueCalculatorInputsBlock = ({
  inputs,
  listGroupItem,
  button,
}: RevenueCalculatorInputsBlockProps): JSX.Element => {
  return (
    <Stack
      direction='column'
      gap='spacing-4xl'
      padding={['spacing-4xl', 'spacing-6xl']}
      paddingSm={['spacing-xl', 'spacing-2xl']}
      background='bg-secondary'
    >
      <Grid
        totalColumns={2}
        totalColumnsSm={1}
        gap='spacing-3xl'
      >
        {inputs.map((input, index) => (
          <RevenueCalculatorInput
            key={index}
            {...input}
          />
        ))}
      </Grid>
      <ListGroupItem {...listGroupItem} />
      {button && (
        <Grid totalColumns={1}>
          <Button {...button} />
        </Grid>
      )}
    </Stack>
  );
};

export default RevenueCalculatorInputsBlock;
